import sessionService from '_services/common/sessionService';

export default (to, from, next) => {
  const user = sessionService.getLocalData('_user');

  if (user.modules.some(item => item.slug === 'settings' || item.slug === 'access-control')) {
    next();
  } else {
    next('/admin/overview');
  }
};
